<button
  [id]="buttonId"
  [name]="name"
  [class]="getButtonClassCssClass()"
  (click)="onButtonClick($event)"
  [title]="tooltip"
  [type]="type"
  [class.incompress]="true"
  [disabled]="disabled">
  <i *ngIf="iconPos === 'left'" [class]="_iconClass"></i>
  {{label}}
  <i *ngIf="iconPos === 'right'" [class]="_iconClass"></i>
</button>
